import React, { useState, useEffect, useRef } from 'react';
import { jwtDecode } from 'jwt-decode';
import Navbar from './components/Navbar/Navbar';
import Modal from './components/Modal/Modal';
import Login from './components/Login/Login';
import Register from './components/Register/Register';
import Inicio from './components/Inicio/Inicio';
// CAMBIO: Se importa PublicView en lugar de Proyectos
import PublicView from './components/Proyectos/Proyectos'; 
import InterventoriaPage from './components/InterventoriaPage/InterventoriaPage';
import CamarasPage from './components/CamarasPage/CamarasPage';
import ContactosPage from './components/ContactosPage/ContactosPage';
import VideosPage from './components/VideosPage/VideosPage';
import AdminVideos from './components/AdminVideos/AdminVideos';
import ArchivoPage from './components/ArchivoPage/ArchivoPage';
import AdminArchivos from './components/AdminArchivos/AdminArchivos';
import CompliancePanel from './components/CompliancePanel/CompliancePanel';
import AdminUsers from './components/AdminUsers/AdminUsers';
import Footer from './components/Footer/Footer';
import LogoCarousel from './components/LogoCarousel/LogoCarousel';

import './App.css';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [activeView, setActiveView] = useState('inicio');
  const [reporteSeleccionado, setReporteSeleccionado] = useState(null);
  const [isAdminMenuOpen, setIsAdminMenuOpen] = useState(false);

  // Estados y refs para el botón arrastrable
  const [fabPosition, setFabPosition] = useState({ x: 20, y: 20 });
  const fabRef = useRef(null);
  const isDragging = useRef(false);
  const wasDragging = useRef(false);
  const startPos = useRef({ x: 0, y: 0 });
  const initialFabPos = useRef({ x: 0, y: 0 });

  // Estado para el estilo dinámico del menú
  const [menuStyle, setMenuStyle] = useState({});

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        if (decoded.exp * 1000 > Date.now()) {
          setIsLoggedIn(true);
          setUserRole(decoded.user.rol);
        } else {
          localStorage.removeItem('token');
        }
      } catch (error) {
        console.error("Token inválido:", error);
        localStorage.removeItem('token');
      }
    }
  }, []);

  // Efecto para calcular la posición del menú
  useEffect(() => {
    if (isAdminMenuOpen && fabRef.current) {
      const fabRect = fabRef.current.getBoundingClientRect();
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      const menuMargin = 10;
      
      const newStyle = {};

      if (fabRect.top > screenHeight / 2) {
        newStyle.bottom = `${window.innerHeight - fabRect.top + menuMargin}px`;
        newStyle.top = 'auto';
      } else {
        newStyle.top = `${fabRect.bottom + menuMargin}px`;
        newStyle.bottom = 'auto';
      }

      if (fabRect.left > screenWidth / 2) {
        newStyle.right = `${screenWidth - fabRect.right}px`;
        newStyle.left = 'auto';
        newStyle.transformOrigin = 'top right';
      } else {
        newStyle.left = `${fabRect.left}px`;
        newStyle.right = 'auto';
        newStyle.transformOrigin = 'top left';
      }
      
      if (newStyle.bottom) {
        newStyle.transformOrigin = newStyle.transformOrigin.replace('top', 'bottom');
      }

      setMenuStyle(newStyle);
    }
  }, [isAdminMenuOpen, fabPosition]);


  // Lógica de arrastre (sin cambios)
  const handleDragStart = (e) => {
    e.preventDefault();
    isDragging.current = true;
    wasDragging.current = false;
    const clientX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    const clientY = e.type === 'touchstart' ? e.touches[0].clientY : e.clientY;
    startPos.current = { x: clientX, y: clientY };
    initialFabPos.current = { ...fabPosition };
    window.addEventListener('mousemove', handleDragMove);
    window.addEventListener('touchmove', handleDragMove);
    window.addEventListener('mouseup', handleDragEnd);
    window.addEventListener('touchend', handleDragEnd);
  };
  const handleDragMove = (e) => {
    if (!isDragging.current) return;
    const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
    const clientY = e.type === 'touchmove' ? e.touches[0].clientY : e.clientY;
    const dx = clientX - startPos.current.x;
    const dy = clientY - startPos.current.y;
    if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
      wasDragging.current = true;
    }
    let newX = initialFabPos.current.x - dx;
    let newY = initialFabPos.current.y - dy;
    const fabElement = fabRef.current;
    if (fabElement) {
      const maxX = window.innerWidth - fabElement.offsetWidth - 10;
      const maxY = window.innerHeight - fabElement.offsetHeight - 10;
      newX = Math.max(10, Math.min(newX, maxX));
      newY = Math.max(10, Math.min(newY, maxY));
    }
    setFabPosition({ x: newX, y: newY });
  };
  const handleDragEnd = () => {
    isDragging.current = false;
    window.removeEventListener('mousemove', handleDragMove);
    window.removeEventListener('touchmove', handleDragMove);
    window.removeEventListener('mouseup', handleDragEnd);
    window.removeEventListener('touchend', handleDragEnd);
  };
  const handleFabClick = () => {
    if (wasDragging.current) {
      wasDragging.current = false;
      return;
    }
    setIsAdminMenuOpen(!isAdminMenuOpen);
  };

  const navigateTo = (view) => {
    setActiveView(view);
  };
  const handleAdminNav = (view) => {
    navigateTo(view);
    setIsAdminMenuOpen(false);
  };
  const handleCreateNew = () => {
    setReporteSeleccionado(null);
    setActiveView('formulario');
  };
  const handleEdit = (reporte) => {
    setReporteSeleccionado(reporte);
    setActiveView('formulario');
  };
  const handleDelete = async (reporteId) => {
    const token = localStorage.getItem('token');
    if (window.confirm('¿Estás seguro de que quieres eliminar este reporte?')) {
        try {
            const response = await fetch(`https://api.interventorsisgafr.com/api/reportes/${reporteId}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (!response.ok) throw new Error('Error al eliminar');
            // Recargar la vista de proyectos para que se actualice
            if(activeView === 'proyectos') {
              window.location.reload(); 
            } else {
              navigateTo('proyectos');
            }
        } catch (error) {
            alert(error.message);
        }
    }
  };
  const [showModal, setShowModal] = useState(false);
  const [isLoginView, setIsLoginView] = useState(true);
  const handleLoginClick = () => setShowModal(true);
  const closeModal = () => setShowModal(false);
  const switchToRegister = () => setIsLoginView(false);
  const switchToLogin = () => setIsLoginView(true);
  const handleSuccessfulLogin = (token) => {
    localStorage.setItem('token', token);
    const decoded = jwtDecode(token);
    setIsLoggedIn(true);
    setUserRole(decoded.user.rol);
    closeModal();
  };
  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    setUserRole(null);
    navigateTo('inicio');
  };

  const renderActiveView = () => {
    switch (activeView) {
      case 'inicio': return <Inicio navigateTo={navigateTo} />;
      // CAMBIO: Asegúrate de que aquí se use PublicView y se pasen todas las props
      case 'proyectos': return <PublicView isAdmin={userRole === 'admin'} onEdit={handleEdit} onDelete={handleDelete} onCreateNew={handleCreateNew} />;
      case 'camaras': return <CamarasPage />;
      case 'videos': return <VideosPage />;
      case 'archivo': return <ArchivoPage />;
      case 'contactos': return <ContactosPage />;
      case 'formulario': return <InterventoriaPage reporteParaEditar={reporteSeleccionado} onVolver={() => navigateTo('proyectos')} />;
      case 'admin_videos': return <AdminVideos onVolver={() => navigateTo('inicio')} />;
      case 'admin_archivos': return <AdminArchivos onVolver={() => navigateTo('inicio')} />;
      case 'compliance_panel': return <CompliancePanel onVolver={() => navigateTo('inicio')} />;
      case 'admin_users': return <AdminUsers onVolver={() => navigateTo('inicio')} />;
      default: return <Inicio navigateTo={navigateTo} />;
    }
  };

  return (
    <div className="App">
      <Navbar isLoggedIn={isLoggedIn} handleLogout={handleLogout} handleLoginClick={handleLoginClick} navigateTo={navigateTo} activeView={activeView} />
      
      {isLoggedIn && userRole === 'admin' && (
        <div className="admin-controls-container">
          <div 
            className={`admin-bar ${isAdminMenuOpen ? 'open' : ''}`}
            style={menuStyle}
          >
            <button onClick={() => handleAdminNav('proyectos')} className="admin-nav-btn">Panel Publicaciones</button>
            <button onClick={() => handleAdminNav('admin_videos')} className="admin-nav-btn">Panel Videos</button>
            <button onClick={() => handleAdminNav('admin_archivos')} className="admin-nav-btn">Panel Archivos</button>
            <button onClick={() => handleAdminNav('compliance_panel')} className="admin-nav-btn">Panel Cumplimiento</button>
            <button onClick={() => handleAdminNav('admin_users')} className="admin-nav-btn">Panel Usuarios</button>
          </div>
          
          <button 
            ref={fabRef}
            className={`admin-fab ${isDragging.current ? 'dragging' : ''}`}
            style={{
              right: `${fabPosition.x}px`,
              bottom: `${fabPosition.y}px`
            }}
            onClick={handleFabClick}
            onMouseDown={handleDragStart}
            onTouchStart={handleDragStart}
          >
            {isAdminMenuOpen ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15.5 8.5c.3-1 .2-2.2-.4-3.1s-1.7-1.3-2.8-1.2L4.6 6.5c-1.1.1-2.1.8-2.6 1.8s-.4 2.2.2 3.2l5.5 7.1c.9 1.1 2.4 1.5 3.8 1l.5-.2.5-.2c1.4-.5 2.3-1.8 2.3-3.3V8.5z"></path><path d="M16 11.5c1.4-1 2.5-2.5 2.5-4.5s-1.1-4-2.5-5"></path></svg>
            )}
          </button>
        </div>
      )}     
     
      <main className="content">
        {renderActiveView()}
      </main>

      <Modal show={showModal} onClose={closeModal}>
        {isLoginView ? (
          <Login switchToRegister={switchToRegister} onLoginSuccess={handleSuccessfulLogin} />
        ) : (
          <Register switchToLogin={switchToLogin} />
        )}
      </Modal>

      <LogoCarousel />

      <Footer />
    </div>
  );
}

export default App;